import {
	type TRovoFeatures,
	type TSearchConfigAPIResponse,
} from '@atlassian/search-client/fetch-search-config';

/**
 * Gets the Rovo features for the given cloudId from site metadata.
 */
export const getRovoFeatures = (
	firstPartyResponse?: TSearchConfigAPIResponse,
	cloudId?: string,
): TRovoFeatures | undefined => {
	if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) {
		return undefined;
	}

	return firstPartyResponse.siteMetadata.find(
		(metadata) => metadata.siteId === cloudId && !!metadata.rovoFeatures,
	)?.rovoFeatures;
};
